<template>
  <!--  背景  -->
  <ul class="act-bg-box">
    <li class="act-bg1"/>
    <li class="act-bg2"/>
    <li class="act-bg3"/>
  </ul>

</template>

<script>
export default {
  name: "InviteActBgBox"
}
</script>

<style lang="scss" scoped>
.act-bg-box {
  font-size: 0;
  position: relative;
  z-index: -1;
  width: 100%;
  margin: 0 auto;

  .act-bg1 {
    @include BgImage(100%, 1100px, 'act/invite-friends/act-bg-3-1-1.jpg', 1);
  }

  .act-bg2 {
    @include BgImage(100%, 590px, 'act/invite-friends/act-bg-3-1-2.jpg', 1);

  }

  .act-bg3 {
    @include BgImage(100%, 557px, 'act/invite-friends/act-bg-3-1-3.jpg', 1);
  }
}
</style>
